
//ROUTE_TO_CONTROLLER_MAP to config mapping route - controller

export const HEADER_ROUTES = {
    TRIEN_KHAI_ROUTES: [
        'dashboard',
        'dotontap',
        'buoc1',
        'buoc2swot',
        'buoc2chienluoc',
        'buoc3',
        'buoc4thanhphan',
        'buoc4',
        'buoc5',
        'buoc6',
        'buoc7',
        'buoc7thucong',
        'buoc8',
        'buoc9',
        'buoc10',
        'buoc11',
        'kien-thuc-loai',
        'hieusuatkpi',
        'logfiles',
        'kpiipoo',
        'quanlyactionplanbophan',
        'tongquancongviec',
        'baocaobsc',
    ],
    EXCEPT_ROUTES: ['bangkehoach', 'kpiipoo', 'login'],
    // Routes cho báo cáo
    BAO_CAO_ROUTES: ['bao-cao-kpis', 'bao-cao-nhanh', 'report-kpi-from-api', 'thong-ke-bao-cao-kpis', 'thong-ke-kpi-khong-dat', 'tong-hop', 'bao-cao-viec-trong-ngay'],
    // Routes cho họp tuần
    HOP_TUAN_ROUTES: [],
    // Routes cho Year Select không cần year
    YEAR_SELECT_ROUTES_NO_YEAR: ['kien-thuc-loai', 'buoc1', 'buoc2swot', 'buoc2chienluoc', 'buoc3', 'buoc4thanhphan', 'logfiles', 'phuongdien', 'vanhoa_dashboard', 'vanhoa_bangkehoach', 'vanhoa_danhgia', 'vanhoa_dotkhaosat', 'vanhoa_anle', 'vanhoa_cauhoianle', 'vanhoa_ngoinha', 'vanhoa_hanhvithenchot', 'vanhoa_hinhmau_tieuchi', 'vanhoa_hinhmau_luachon', 'vanhoa_hinhmau_danhgia'],
    // Routes cho Year Select cần year
    YEAR_SELECT_ROUTES_YEAR: ['bangkehoach', 'buoc4', 'buoc5', 'buoc6', 'kpiipoo', 'thietlap', 'thuvienkpi', 'buoc7thucong', 'buoc7-danhsachthucong', 'hieusuatkpi', 'buoc9', 'vanhoa_actionplan', 'buoc7', 'kpichung', 'quanlyactionplanbophan', 'co-cau-giai-doan', 'co-cau-giai-doan/tai-co-cau'],

    // Routes cho VuotCap
    VUOTCAP_CURRENT_ROUTES: [],
    // Routes cho Công ty
    CONGTY_ROUTES: ['buoc1', 'buoc2swot', 'buoc2chienluoc', 'buoc3', 'buoc4thanhphan'],
    // Routes cho nhân viên
    HUONG_DAN_ROUTES: [
        'buoc1', 'buoc2swot', 'buoc2chienluoc', 'buoc3', 'buoc4thanhphan', 'buoc5', 'buoc6',
        'kien-thuc-loai', 'thietlap', 'dotontap', 'buoc9',
        // Văn hóa — chỉ trang có `btn tourguide` trên toolbar CMS cũ
        //'vanhoa_dashboard',
        'vanhoa_timeline',
        'vanhoa_bangkehoach',
        'vanhoa_danhgia',
        'vanhoa_ngoinha',
        'vanhoa_hanhvithenchot',
        'vanhoa_anle',
        'vanhoa_cauhoianle',
        'vanhoa_hinhmau_tieuchi',
        'vanhoa_hinhmau_luachon',
        'vanhoa_hinhmau_danhgia',
        'vanhoa_tieuchigankettrainghiemdiemcham',
        'vanhoa_tieuchitruongthanhvanhoa',
        'vanhoa_dotkhaosat',
        'vanhoa_actionplan',
    ],
    VAN_HOA_ROUTES: [
        'vanhoa_ngoinha',
        'vanhoa_hanhvithenchot',
        'vanhoa_anle',
        'vanhoa_cauhoianle',
        'vanhoa_bangkehoach',
        'vanhoa_danhgia',
        'vanhoa_dotontap',
        'vanhoa_actionplan',
        'vanhoa_dotkhaosat',
        'vanhoa_dashboard',
        'vanhoa_hinhmau_tieuchi',
        'vanhoa_hinhmau_luachon',
        'vanhoa_hinhmau_danhgia',
        'vanhoa_tieuchigankettrainghiemdiemcham',
    ],

};

// Tất cả routes cần tree select
export const TREE_SELECT_ROUTES = [
    ...HEADER_ROUTES.TRIEN_KHAI_ROUTES,
    ...HEADER_ROUTES.BAO_CAO_ROUTES,
    ...HEADER_ROUTES.HOP_TUAN_ROUTES,
    ...HEADER_ROUTES.EXCEPT_ROUTES,
    ...HEADER_ROUTES.CONGTY_ROUTES,
    ...HEADER_ROUTES.VAN_HOA_ROUTES,
];
// Routes không cho nhân viên
export const NOT_ALLOW_EMPLOYEE_ROUTES = ['buoc4thanhphan', 'kpiipoo', ...HEADER_ROUTES.CONGTY_ROUTES];

/** Ẩn cây Tổ chức trên header (làm bài / kết quả đợt ôn tập BSC + Văn hóa) */
export const HIDE_ORG_TREE_PATH_PREFIXES = [
    '/dot-on-tap/lam-bai',
    '/dot-on-tap/ket-qua',
    '/van-hoa/dot-on-tap/lam-bai',
    '/van-hoa/dot-on-tap/ket-qua',
] as const;

/** VH: không hiển thị công ty cha trên header — giữ luồng chọn bộ phận cũ (Đào tạo VH, Action Plan). */
export const VAN_HOA_EXCLUDE_COMPANY_HEADER_PATH_PREFIXES = [
    '/van-hoa/dot-on-tap',
    '/van-hoa/du-an',
    '/van-hoa/cong-viec-du-an',
    '/van-hoa/quan-ly-action-plan-bo-phan',
] as const;

export function normalizeHeaderPath(pathname: string | undefined | null): string {
    const raw = String(pathname || '').split('?')[0].split('#')[0];
    if (!raw || raw === '/') return '/';
    return raw.length > 1 && raw.endsWith('/') ? raw.slice(0, -1) : raw;
}

/** VH: header giống BSC — bộ phận + kiêm nhiệm (không giai đoạn, không công ty cha). */
export function shouldUseVanHoaBscStyleHeader(pathname: string | undefined | null): boolean {
    const normalized = normalizeHeaderPath(pathname);
    if (!normalized.startsWith('/van-hoa')) return false;
    return VAN_HOA_EXCLUDE_COMPANY_HEADER_PATH_PREFIXES.some(
        (prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`),
    );
}

/** VH có tổ chức header: hiển thị công ty cha gần nhất (trừ Đào tạo VH & Action Plan). */
export function shouldUseVanHoaCompanyHeader(pathname: string | undefined | null): boolean {
    const normalized = normalizeHeaderPath(pathname);
    if (!normalized.startsWith('/van-hoa')) return false;
    return !VAN_HOA_EXCLUDE_COMPANY_HEADER_PATH_PREFIXES.some(
        (prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`),
    );
}

export function isHideOrgTreePath(pathname: string | undefined | null): boolean {
    if (!pathname) return false;
    const normalized = pathname.length > 1 && pathname.endsWith('/')
        ? pathname.slice(0, -1)
        : pathname;
    return HIDE_ORG_TREE_PATH_PREFIXES.some(
        (prefix) => normalized === prefix || normalized.startsWith(`${prefix}/`)
    );
}

export function isLogfilesPath(pathname: string | undefined | null): boolean {
    const normalized = normalizeHeaderPath(pathname);
    return normalized === '/logfiles' || normalized.startsWith('/logfiles/');
}

/**
 * Action Plan V2 — chế độ Quản lý: tree header chỉ chọn bộ phận (ẩn icon/node nhân viên).
 */
export function shouldHideEmployeeInTreeHeader(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    pathname: string | undefined | null,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    query?: Record<string, string | string[] | undefined> | null,
): boolean {
    // const normalized = normalizeHeaderPath(pathname);
    // if (normalized !== '/action-plan-v2' && !normalized.startsWith('/action-plan-v2/')) {
    //     return false;
    // }
    // const viewRaw = query?.view;
    // const view = Array.isArray(viewRaw) ? viewRaw[0] : viewRaw;
    // return String(view || '') === 'manager';
    return false;
}

/** Trang chi tiết làm bài / kết quả đợt ôn tập — không phụ thuộc cây tổ chức header. */
export function isStandaloneDotOnTapDetailPath(pathname: string | undefined | null): boolean {
    return isHideOrgTreePath(pathname);
}
